import FiscalDocTypeEnum from '@/api/Enums/FiscalDocTypeEnum'
import Printer from '@/lib/print/printer.js'
import AppData from '@/mixins/appdata'
import {emailIsGuest} from '@/lib/helper/helper'
import isDesktopApp from '@/desktop-app/isDesktopApp'
import Auth from '@/mixins/auth'
import DataStore from '@/api/DataStore/DataStore.js'

export default {
  mixins: [Auth, AppData],

  data() {
    return {
      selectedReceiptItem                  : null,
      confirmCancelFiscalDocDialogVisible  : false,
      confirmConvertReceiptToInvoiceVisible: false,
      customerSelectEmailDialogVisible     : false,
      customerSelectEmailDialogData        : null,
      customerSelectCompanyDialogVisible   : false,
      customerSelectCompanyDialogData      : null
    }
  },

  created() {
    this.$bus.$on('fiscal-document:view', this.viewFiscalDocument)
    this.$bus.$on('fiscal-document:create', this.createFiscalDocument)
    this.$bus.$on('fiscal-document:payment-update', this.updateFiscalDocumentPayment)
    this.$bus.$on('fiscal-document:cancel', this.confirmCancelFiscalDocument)
    this.$bus.$on('fiscal-document:print', this.printFiscalDocument)
    this.$bus.$on('fiscal-document:email', this.emailFiscalDocument)
    this.$bus.$on('fiscal-document:retry', this.retryReceipt)
    this.$bus.$on('fiscal-document:convert-to-invoice', this.confirmConvertReceiptToInvoice)

    this.$bus.$on(window.SocketCommand.Receipt.Generate, this.issueFiscalDocumentResult)
    this.$bus.$on(window.SocketCommand.Receipt.NotifyPrint, this.printFiscalDocumentResult)
    this.$bus.$on(window.SocketCommand.Receipt.NotifyEmail, this.emailFiscalDocumentResult)
    this.$bus.$on(window.SocketCommand.Receipt.Cancel, this.cancelFiscalDocumentResult)
    this.$bus.$on(window.SocketCommand.Receipt.Retry, this.onRetryReceiptResponse)
    this.$bus.$on(window.SocketCommand.Receipt.ConvertToInvoice, this.convertReceiptToInvoiceResult)
  },

  beforeDestroy() {
    this.$bus.$off('fiscal-document:view', this.viewFiscalDocument)
    this.$bus.$off('fiscal-document:create', this.createFiscalDocument)
    this.$bus.$off('fiscal-document:payment-update', this.updateFiscalDocumentPayment)
    this.$bus.$off('fiscal-document:cancel', this.confirmCancelFiscalDocument)
    this.$bus.$off('fiscal-document:print', this.printFiscalDocument)
    this.$bus.$off('fiscal-document:email', this.emailFiscalDocument)
    this.$bus.$off('fiscal-document:retry', this.retryReceipt)
    this.$bus.$off('fiscal-document:convert-to-invoice', this.confirmConvertReceiptToInvoice)

    this.$bus.$off(window.SocketCommand.Receipt.Generate, this.issueFiscalDocumentResult)
    this.$bus.$off(window.SocketCommand.Receipt.NotifyPrint, this.printFiscalDocumentResult)
    this.$bus.$off(window.SocketCommand.Receipt.NotifyEmail, this.emailFiscalDocumentResult)
    this.$bus.$off(window.SocketCommand.Receipt.Cancel, this.cancelFiscalDocumentResult)
    this.$bus.$off(window.SocketCommand.Receipt.Retry, this.onRetryReceiptResponse)
    this.$bus.$off(window.SocketCommand.Receipt.ConvertToInvoice, this.convertReceiptToInvoiceResult)
  },

  computed: {
    selectedOrderHasRefundableTransactions() {
      return this.orderHasRefundableTransactions(this.selectedReceiptItem)
    },
    selectedOrderRefundableTransactionsTotal() {
      return this.orderRefundableTransactionsTotal(this.selectedReceiptItem)
    },
    machineHasPrintersForFiscalDocs() {
      return this.appMachineFiscalDocTotalsZPrintersActive.length && this.appHasFiscalDocTotalsZPrinters
    }
  },

  methods: {
    viewFiscalDocument(docUrl) {
      if (!docUrl) return

      window.open(docUrl, '_blank')
    },

    updateFiscalDocumentPayment(order, data = null) {
      if (!order) return

      window.callAS(window.SocketCommand.Receipt.PaymentUpdate, {OrderId: order.Id, Email: data?.Email || false, EmailAddresses: data?.EmailAddresses || []})
    },

    createFiscalDocument(order, docType, data = null, command = window.SocketCommand.Receipt.Generate) {
      if (FiscalDocTypeEnum.isInvoice(docType)) {
        this.customerSelectCompanyDialogData = {
          companies: [],
          countries: [],
          order    : order,
          docType  : docType,
          data     : data,
          command  : command
        }

        this.customerSelectCompanyDialogData.countries = Array.isArray(this.$DataStore.countries) ? this.$DataStore.countries : []
        this.customerSelectCompanyDialogData.companies = Array.isArray(this.$DataStore.companies) ? this.$DataStore.companies : []

        if (data?.Company) {
          this.issueFiscalDocument(order, docType, data, command)
        } else {
          this.customerSelectCompanyDialogVisible = true
        }
      } else {
        this.issueFiscalDocument(order, docType, data, command)
      }
    },

    cancelSelectCompanyForInvoiceDialog() {
      this.$bus.$emit('invoice-company:canceled')
    },

    createOrConvertFiscalDocument(company, payload) {
      this.$bus.$emit('invoice-company:selected', company)

      if (!payload) payload = {}
      if (!payload?.data) payload.data = {}
      payload.data.Company = company

      if (payload.command === window.SocketCommand.Receipt.ConvertToInvoice) {
        this.convertReceiptToInvoice(payload.order, payload.data, payload.command)
      } else {
        this.issueFiscalDocument(payload.order, payload.docType, payload.data, payload.command)
      }
    },

    issueFiscalDocument(order, docType, data = null, command = window.SocketCommand.Receipt.Generate, resultCommand = window.SocketCommand.Receipt.Generate) {
      if ((!order?.Id && (!order?.TableId || !order?.CartId || !order?.Timestamp)) || !docType || (FiscalDocTypeEnum.isInvoice(docType) && !data?.Company)) return

      const emailAddresses = data?.EmailAddresses ?? []
      if (order?.Email && !emailIsGuest(order?.Email) && !emailAddresses.includes(order.Email)) emailAddresses.push(order.Email)
      const emailReceipt = data?.Email ?? this.ReceiptsEmailNotify ? !!emailAddresses.length : false
      const printReceipt = data?.Print ?? this.ReceiptsPrintNotify
      let payload = null

      if (command === window.SocketCommand.Receipt.GenerateFromCartTablePaymentTimestamp) {
        // Issue Doc from Table Payment
        payload = {
          TableId       : order.TableId,
          CartId        : order.CartId,
          Timestamp     : order.Timestamp,
          Company       : data?.Company || null,
          ReceiptType   : docType || FiscalDocTypeEnum.RECEIPT,
          Print         : printReceipt,
          Email         : emailReceipt,
          EmailAddresses: emailReceipt ? emailAddresses : []
        }
      } else {
        if (order?.TableId && order?.CartId && order?.Timestamp) {
          // Issue Doc from Table Cart
          payload = {
            TableId       : order.TableId,
            CartId        : order.CartId,
            Timestamp     : order.Timestamp,
            Print         : printReceipt,
            Email         : emailReceipt,
            EmailAddresses: emailReceipt ? emailAddresses : [],
            Type          : docType,
            Company       : data?.Company || null
          }
        } else {
          // Issue Doc from Order
          payload = {
            Id                    : order.Id,
            Print                 : printReceipt,
            Email                 : emailReceipt,
            EmailAddresses        : emailReceipt ? emailAddresses : [],
            Type                  : docType,
            Company               : data?.Company || null,
            DeliveryStaffCompleted: data?.DeliveryStaffCompleted || false
          }
        }
      }

      if (payload) {
        window.callAS(command, payload, resultCommand || command, 20000)
      }
    },

    issueFiscalDocumentResult(result, payload) {
      if (result?.status === 'success') {
        this.$bus.$emit(window.SocketCommand.Receipt.Update, payload)
        this.customerSelectCompanyDialogData = null

        this.$bus.$emit('app-show-notification', {
          body: this.$t('Common.Misc.Notification.IssueReceipt.Success'),
          type: 'success',
          icon: 'check'
        })
      } else {
        this.$bus.$emit('app-show-notification', {
          body   : this.$t('Common.Misc.Notification.IssueReceipt.Error'),
          type   : 'error',
          icon   : 'warning',
          timeout: 6000
        })
      }
    },

    printFiscalDocument(receiptId) {
      if (!receiptId) return

      if (isDesktopApp() || this.userIsWaiter) {
        window.callAS(window.SocketCommand.Receipt.Notify, {
          Id            : receiptId,
          Print         : true,
          Email         : false,
          EmailAddresses: [],
          Guid          : this.machineGuidForManualFiscalDocPrint()
        }, window.SocketCommand.Receipt.NotifyPrint, 20000)
      } else {
        Printer.printReceipt(receiptId)
      }
    },
    printFiscalDocumentResult(result, payload) {
      if (result?.status === 'success') {
        this.$bus.$emit('app-show-notification', {
          body: this.$t('Common.Misc.Notification.PrintReceipt.Success'),
          type: 'info',
          icon: 'print'
        })
      } else {
        this.$bus.$emit('app-show-notification', {
          body   : this.$t('Common.Misc.Notification.PrintReceipt.Error'),
          type   : 'error',
          icon   : 'warning',
          timeout: 6000
        })
      }
    },

    emailFiscalDocument(receiptId, order = null, data = null) {
      if (!receiptId) return

      this.customerSelectEmailDialogData = {
        receiptId: receiptId,
        order    : order,
        data     : data
      }

      this.customerSelectEmailDialogVisible = true
    },
    emailFiscalDocumentConfirm() {
      const {
        receiptId,
        order,
        data
      } = this.customerSelectEmailDialogData

      const emailAddresses = data?.EmailAddresses ?? []
      if (order?.Email && !emailIsGuest(order?.Email) && !emailAddresses.includes(order.Email)) emailAddresses.push(order.Email)
      const emailReceipt = data?.Email ?? data?.email ?? this.ReceiptsEmailNotify ? !!emailAddresses.length : false
      const notifyFrom = data?.From || null
      const notifyFromId = order?.Id || order?.OrderId || order?.TableId || null
      if (!emailReceipt) return

      window.callAS(window.SocketCommand.Receipt.Notify, {
        Id            : receiptId,
        Print         : false,
        From          : notifyFrom,
        FromId        : notifyFromId,
        Email         : emailReceipt,
        EmailAddresses: emailReceipt ? emailAddresses : []
      }, window.SocketCommand.Receipt.NotifyEmail, 20000)

      this.customerSelectEmailDialogData = null
    },
    emailFiscalDocumentResult(response, payload) {
      if (response?.status === 'success') {
        this.$bus.$emit('app-show-notification', {
          body: this.$t('Common.Misc.Notification.EmailReceipt.Success'),
          type: 'info',
          icon: 'email'
        })
      } else {
        this.$bus.$emit('app-show-notification', {
          body   : this.$t('Common.Misc.Notification.EmailReceipt.Error'),
          type   : 'error',
          icon   : 'warning',
          timeout: 6000
        })
      }
    },

    confirmConvertReceiptToInvoice(order) {
      if (!order?.ReceiptId) return

      const command = window.SocketCommand.Receipt.ConvertToInvoice
      const data = {
        Id     : order.ReceiptId,
        Print  : this.ReceiptsPrintNotify ?? true,
        Company: null
      }

      this.customerSelectCompanyDialogData = {
        companies: [],
        countries: [],
        data     : data,
        order    : order,
        command  : command
      }

      this.customerSelectCompanyDialogData.countries = Array.isArray(this.$DataStore.countries) ? this.$DataStore.countries : []
      this.customerSelectCompanyDialogData.companies = Array.isArray(this.$DataStore.companies) ? this.$DataStore.companies : []
      this.customerSelectCompanyDialogVisible = true
    },
    convertReceiptToInvoice(order, data, command = window.SocketCommand.Receipt.ConvertToInvoice) {
      window.callAS(command, {
        Id     : order.ReceiptId,
        Print  : data?.Print ?? this.ReceiptsPrintNotify,
        Company: data?.Company || null,
        OrderId: order?.OrderId || null,
        TableId: order?.TableId || null,
        Guid   : this.machineGuidForManualFiscalDocPrint()
      })
    },
    convertReceiptToInvoiceResult(response, payload) {
      if (response?.status === 'success') {
        this.$bus.$emit(window.SocketCommand.Receipt.Update, payload)
        this.customerSelectCompanyDialogData = null

        this.$bus.$emit('app-show-notification', {
          body: this.$t('Common.Misc.Notification.ConvertReceipt.Success'),
          type: 'success',
          icon: 'check'
        })
      } else {
        this.$bus.$emit('app-show-notification', {
          body   : this.$t('Common.Misc.Notification.ConvertReceipt.Error'),
          type   : 'error',
          icon   : 'warning',
          timeout: 6000
        })
      }
    },

    confirmCancelFiscalDocument(order) {
      if (!order) return

      this.selectedReceiptItem = order
      this.confirmCancelFiscalDocDialogVisible = true
    },
    cancelFiscalDocument(order, refund = false) {
      if (!order?.ReceiptId) return

      window.callAS(window.SocketCommand.Receipt.Cancel, {
        Id           : order.ReceiptId,
        TableId      : order?.TableId || null,
        OrderId      : order?.OrderId || null,
        BroadcastList: order?.BroadcastList ?? false,
        Refund       : refund ?? false
      })
    },
    cancelFiscalDocumentResult(response, payload) {
      if (response?.status === 'success') {
        this.$bus.$emit(window.SocketCommand.Receipt.Update, payload)

        this.$bus.$emit('app-show-notification', {
          body: this.$t('Common.Misc.Notification.CancelReceipt.Success'),
          type: 'success',
          icon: 'check'
        })
      } else {
        this.$bus.$emit('app-show-notification', {
          body   : this.$t('Common.Misc.Notification.CancelReceipt.Error'),
          type   : 'error',
          icon   : 'warning',
          timeout: 6000
        })
      }
    },

    retryReceipt(receiptId) {
      window.callAS(window.SocketCommand.Receipt.Retry, {Id: receiptId})
    },
    onRetryReceiptResponse(response) {
      if (response?.status === 'success') {
        this.$bus.$emit('app-show-notification', {
          body: this.$t('Common.Misc.Notification.RetryReceipt.Success'),
          type: 'success',
          icon: 'check'
        })
      } else {
        this.$bus.$emit('app-show-notification', {
          body   : this.$t('Common.Misc.Notification.RetryReceipt.Error'),
          type   : 'error',
          icon   : 'warning',
          timeout: 6000
        })
      }
    },

    orderHasRefundableTransactions(order) {
      if (!order) return false

      return order?.PaymentMethods?.some(payment => payment.Refundable)
    },

    orderRefundableTransactionsTotal(order) {
      if (!order) return 0

      return order?.PaymentMethods?.filter(payment => payment.Refundable)?.reduce((a, b) => a + parseFloat(b.Amount), 0) || 0
    },

    machineGuidForManualFiscalDocPrint() {
      if (this.machineHasPrintersForFiscalDocs) return DataStore?.app?.guid || null

      return null
    }
  }
}
